export const HOME = '/' as const;
export const SIGN_UP = '/signup' as const;
export const SIGN_IN = '/signin' as const;
export const MY_TEAMS = '/my-teams' as const;
export const ACCOUNT = '/account' as const;
export const ABOUT = '/about' as const;
export const ADMIN = '/admin' as const;
export const ENCYCLOPEDIA = '/encyclopedia' as const;
export const PASSWORD_FORGET = '/pw-forget' as const;
